/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ChartBar from '../../../components/Chartjs/BarChart'
import Reports from '../../../functions/logic/Reports'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import Maintenance from '../../../functions/logic/Maintenance'
import Select2 from '../../../components/Select2'


export default function Earns() {
    const param = useParams()
    const [spiner, setSpiner] = useState(false)
    const [dataKey, setDataKey] = useState(false)
    const [dataChart, setDataChart] = useState([])
    const userToken = localStorage.getItem('userToken')
    const [year, setYear] = useState([])
    const [yearNow, setYearNow] = useState([])
    const [yearActual, setYearActual] = useState(new Date().getFullYear().toString())
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [monthNumber, setMonthNumber] = useState(0)
    const columns = ['Fecha', 'Sku', 'Nombre', 'Cantidad', 'Precio', 'Iva', 'SubTotal', 'Tarifa Descuento', 'Precio Descuento'
    , 'Iva Descuento', 'Subtotal Descuento', 'Total Descuento']

    useEffect(() => {
        getEarnsChart(param)
    }, [param])

    const getEarnsChart = async (param) => {
        setSpiner(true)
        const actualYear = new Date()
        global.MENU_MODULE_SELECT = 'reporteria'
        const response = await Reports.earnsDataLogic(userToken, param.moduleId, actualYear.getFullYear())
        const yearsResp = Maintenance.getYears()
        setYear(yearsResp)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        setDataChart(response)
        setDataKey('Utilidad')
        setSpiner(false)
        setYearNow(actualYear.getFullYear())
    }

    const handledClick = async (event) => {
        const monthNumber = event["activePayload"]?.[0]?.["payload"]?.["monthnumber"]

        if (!monthNumber) {
            setSpiner(false)
            return
        }

        setSpiner(true)
        setMonthNumber(monthNumber)

        try {
            const response = await Reports.eransDataByMonthLogic(userToken, param.moduleId, event["activePayload"][0]["payload"]["monthnumber"], yearNow, 1, 5, 'no')

            if (response && response.responseTableMapper && response.responseTableMapper.length > 0) {
                setdata(response.responseTableMapper)
                setTotalRows(response.total_records)
            } else {
                setdata([])
                setTotalRows(0)
            }
        } catch (error) {
            console.error("Error al obtener los datos:", error)
        } finally {
            setSpiner(false)
        }
    }

    /*const handledClick = async (event) => {
        setSpiner(true)
        const response = await Reports.eransDataByMonthLogic(userToken, param.moduleId, event["activePayload"][0]["payload"]["monthnumber"], yearNow, 1, 5, 'no')
        setUsers(response)
        setSpiner(false)
    }*/

    const handlePageChange = async (page, perPage) => {
        setSpiner(true)
        const response = await Reports.eransDataByMonthLogic(userToken, param.moduleId, monthNumber, yearNow, page, perPage, 'no')
        setdata(response["responseTableMapper"])
        setTotalRows(response.total_records)
        setSpiner(false)
    }

    const handleOnChange = async (event) => {
        setSpiner(true)
        setYearActual(event.target.value)
        setYearNow(event.target.value)

        setdata([])

        const response = await Reports.earnsDataLogic(userToken, param.moduleId, event.target.value)
        if (response && response.length > 0) {
            setDataChart(response)
        } else {
            setDataChart([])
        }

        setSpiner(false)
    }

    const handleSearch = async (item) => {
        setSpiner(true)
    
        setdata([])
        
        let response
        if (item === "") {
            response = await Reports.eransDataByMonthLogic(userToken, param.moduleId, monthNumber, yearNow, 1, 5, 'no')
        } else {
            response = await Reports.eransDataByMonthLogic(userToken, param.moduleId, monthNumber, yearNow, 1, 1, 'no')
        }
        
        if (response && response.responseTableMapper && response.responseTableMapper.length > 0) {
            setdata(response.responseTableMapper)
            setTotalRows(response.total_records)
        } else {
            setdata([])
            setTotalRows(0)
        }
    
        setSpiner(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <div className="content-wrapper">
                <section className="content-header">
                    <Select2
                        year={yearActual}
                        data={year}
                        col={'col-md-2'}
                        header={""}
                        TextInit={"Seleccione un año"}
                        handledOnChange={handleOnChange}
                    />
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Reporte utilidad por mes ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <ChartBar handledClick={handledClick} dataChart={dataChart} dataKey={dataKey} />
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Detalle por mes ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >
            </div >
        </>
    )

}
